import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const StairOnlyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "StairOnlyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5223 22.374H17.7862C17.7232 22.374 17.6606 22.3637 17.601 22.3437L17.5914 22.3405H2.83782C2.51669 22.3405 2.25635 22.0801 2.25635 21.759V18.0294C2.25635 17.7083 2.51669 17.448 2.83782 17.448H5.99261V14.2999C5.99261 14.0988 6.09468 13.9216 6.24981 13.8172C6.34312 13.7528 6.45588 13.7151 6.57741 13.7151H9.72887V10.5703C9.72887 10.369 9.83121 10.1916 9.98666 10.0872C10.0798 10.0231 10.1924 9.98554 10.3137 9.98554H13.4651V6.84079C13.4651 6.63972 13.5672 6.46252 13.7223 6.35809C13.8156 6.29374 13.9284 6.25598 14.0499 6.25598H17.2047V3.1079C17.2047 2.78677 17.4651 2.52643 17.7862 2.52643H21.5224C21.8436 2.52643 22.1039 2.78677 22.1039 3.1079L22.1038 21.7925C22.1038 22.1136 21.8435 22.374 21.5223 22.374ZM17.8812 21.211H20.9409L20.9409 3.68937H18.3676V6.83745C18.3676 7.15858 18.1073 7.41892 17.7862 7.41892H14.628V10.567C14.628 10.8881 14.3677 11.1485 14.0466 11.1485H10.8918V14.2965C10.8918 14.6177 10.6314 14.878 10.3103 14.878H7.15552V18.0294C7.15552 18.3506 6.89518 18.6109 6.57405 18.6109H3.4193V21.1775H17.6865C17.7495 21.1775 17.812 21.1877 17.8717 21.2078L17.8812 21.211Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.67395 3.78424H6.91386C6.59273 3.78424 6.33239 4.04458 6.33239 4.36571C6.33239 4.68684 6.59273 4.94718 6.91386 4.94718H8.26834L3.69119 9.51615C3.46391 9.743 3.46356 10.1112 3.69045 10.3385C3.80403 10.4522 3.953 10.5092 4.10198 10.5092C4.2506 10.5092 4.39927 10.4525 4.51277 10.3392L9.09247 5.76772V7.1208C9.09247 7.44193 9.35281 7.70227 9.67394 7.70227C9.99507 7.70227 10.2554 7.44193 10.2554 7.1208V4.36571C10.2554 4.04458 9.99508 3.78424 9.67395 3.78424Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default StairOnlyIcon;
